/* eslint-disable no-restricted-globals */
/* eslint-disable no-throw-literal */
import { Button } from "semantic-ui-react"
import { responseError } from "../../../helpers"
import { useDispatch, useSelector } from "react-redux"
import { sysAPI } from "../../../apis/SysAPI"
import { setSnackbar } from "../../../actions/snackbar.actions"

const CopyGeneralRecovableTrust = ({clientId, assetIndex, docId, loading, setLoading}) => {
    const dispatch = useDispatch()
    const estateManualInput = useSelector(state => state.estateManualInput);
    const estateManualInputRequest = useSelector(state => state.estateManualInputRequest);

    const getInformation = async () => {
        const confirmacion = confirm(`Confirming this action will delete everything you currently have in this section and replace it with the data from Client.\n\nThis action cannot be undone`)
        if(!confirmacion){
            return
        }

        setLoading(true)
        try {
            const indexToGet = assetIndex === 1 ? 2 : 1
            const {data: manual_input} = await sysAPI.get(`/generic-manual-input`, {
                params: {
                    clientId,
                    area: "estate",
                    index: indexToGet
                }
            })

            let documentIdGeneral = null;
            for(const keyDocument in manual_input.documents){
                if(manual_input.documents[keyDocument].type  === "General"){
                    documentIdGeneral = keyDocument
                    break
                }
            }
            if(!documentIdGeneral){
                throw {message: "No general document found"}
            }

            for(const keyDatapoint in manual_input.datapoints){
                if(keyDatapoint.includes(`${documentIdGeneral}___estateQuestion___rev`)){
                    const newKeyDatapoint = keyDatapoint.replace(`${documentIdGeneral}___`, "");
                    estateManualInput[docId][newKeyDatapoint] = manual_input.datapoints[keyDatapoint]
                }
            }
            dispatch(setSnackbar({message: "Information copied!"}))
        } catch (error) {
            responseError(error, undefined, "CopyGeneralRecovableTrust.getInformation", dispatch)
        }
        setLoading(false)
    }

    return <>
        <Button disabled={estateManualInputRequest?.status === "Ready" || loading} color="violet" loading={loading} onClick={() => getInformation()}>Import {assetIndex === 1 ? "Co-Client" : "Client"} Information</Button>
    </>
}

export default CopyGeneralRecovableTrust